import { Box } from "@mui/material";

export default function Stars() {
  return (
    <>
      {/* small stars */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
          zIndex: 0,
          "& div": {
            position: "absolute",
            backgroundColor: "#fff",
            borderRadius: "50%",
          },
        }}
      >
        {[...Array(150)].map((_, i) => (
          <Box
            key={i}
            sx={{
              width: `${Math.random() * 2 + 0.5}px`,
              height: `${Math.random() * 2 + 0.5}px`,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              opacity: Math.random() * 0.5 + 0.2,
              animation: `twinkle${Math.random() > 0.5 ? "1" : "2"} ${Math.random() * 3 + 2}s infinite ease-in-out`,
            }}
          />
        ))}
      </Box>

      {/* light stars */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
          zIndex: 0,
        }}
      >
        {[...Array(30)].map((_, i) => (
          <Box
            key={i}
            sx={{
              position: "absolute",
              width: `${Math.random() * 4 + 2}px`,
              height: `${Math.random() * 4 + 2}px`,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              background: `radial-gradient(circle, #fff, ${["#ffeaa7", "#74b9ff", "#a29bfe", "#fd79a8"][Math.floor(Math.random() * 4)]})`,
              borderRadius: "50%",
              opacity: Math.random() * 0.6 + 0.3,
              boxShadow: `0 0 ${Math.random() * 10 + 5}px rgba(255,255,255,0.3)`,
              animation: `pulse ${Math.random() * 4 + 2}s infinite ease-in-out`,
            }}
          />
        ))}
      </Box>

      {/* stars animations */}
      <style>
        {`
          @keyframes twinkle1 {
            0%, 100% { opacity: 0.2; transform: scale(1); }
            50% { opacity: 0.8; transform: scale(1.2); }
          }
          @keyframes twinkle2 {
            0%, 100% { opacity: 0.3; transform: scale(1); }
            50% { opacity: 0.9; transform: scale(1.5); }
          }
          @keyframes pulse {
            0%, 100% { opacity: 0.3; transform: scale(1); }
            50% { opacity: 1; transform: scale(1.2); }
          }
          ::-webkit-scrollbar {
            width: 6px;
            background: #0a0a1a;
          }
        `}
      </style>
    </>
  );
}
